// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;

function MM_cmp_save_or_discard(props) {
  var onContinueEditing = props.onContinueEditing;
  var onSave = props.onSave;
  var onDiscard = props.onDiscard;
  var __removeStmt = props.removeStmt;
  var removeStmt = __removeStmt !== undefined ? __removeStmt : false;
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, React.createElement(Expln_React_Row.make, {
                            children: Caml_option.some(React.createElement("span", {
                                      style: {
                                        fontWeight: "bold"
                                      }
                                    }, "Discard changes or save?"))
                          }), React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Button, {
                                            onClick: (function (param) {
                                                onDiscard();
                                              }),
                                            children: Caml_option.some(removeStmt ? "Discard, remove step" : "Discard, use this \u2192")
                                          })), React.createElement("td", undefined, removeStmt ? null : props.contOld)), React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Button, {
                                            onClick: (function (param) {
                                                onSave();
                                              }),
                                            children: "Save, use this \u2192"
                                          })), React.createElement("td", undefined, props.contNew)))), React.createElement(Button, {
                            onClick: (function (param) {
                                onContinueEditing();
                              }),
                            children: "Continue Editing"
                          })))
            });
}

var make = MM_cmp_save_or_discard;

exports.make = make;
/* react Not a pure module */
